
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { MainLayout } from '@/components/layouts/MainLayout';
import { createNonLocalizedPageGetServerSideProps } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const PrivacyPolicy = dynamic(async () => await import('@/templates/PrivacyPolicy/PrivacyPolicy'), {
    loading: LoaderScreen,
});
const privacy = () => {
    return (<MainLayout title='Privacy Policy'>
			<PrivacyPolicy />
		</MainLayout>);
};
export default privacy;
const getServerSideProps = createNonLocalizedPageGetServerSideProps('/privacy-policy');

    async function __Next_Translate__getServerSideProps__1a1a20bc24b__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/privacy-policy',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bc24b__ as getServerSideProps }
  